<template>
  <v-dialog
    v-model="dialog"
    scrollable
    persistent
    max-width="500px"
    transition="dialog-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <!-- v-on="on" -->
      <v-btn small v-bind="attrs" v-on="on" icon>
        <v-icon small>fas fa-pen</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="teal darken-3 white--text" dense class="mb-3">
        <v-toolbar-title>
          {{ inventory.AccountName }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="dialog = false">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- <h1>Hellow</h1> -->
      <v-card-text>
        <v-form v-model="valid" ref="EnvEditeForm" class="py-3">
          <v-text-field
            outlined
            readonly
            label="Item Name"
            v-model="inventory.InvName"
            :rules="ItemNameRule"
            required
          ></v-text-field>
          <!-- <v-text-field
            outlined
            type="number"
            :label="inventory.UnitType + ' QTY'"
            v-model.number="QtyItems"
            :rules="QtyRule"
            required
          ></v-text-field> -->
          <BaseNumInput
            outlined
            :label="inventory.UnitType + ' QTY'"
            :rules="QtyRule"
            v-model.number="QtyItems"
          ></BaseNumInput>
          <!-- <BaseNumInput
            outlined
            :rules="[UnitRule]"
            label="Unit QTY"
            v-model.number="UnitQty"
          ></BaseNumInput> -->
          <v-text-field
            outlined
            :rules="[UnitRule]"
            label="Unit QTY"
            v-model.number="UnitQty"
            required
          ></v-text-field>
          <BaseNumInput
            outlined
            :label="inventory.UnitType + ' PRICE'"
            v-model.number="inventory.unitPrice"
          ></BaseNumInput>
          <!-- <v-text-field
            outlined
            type="number"
            :label="inventory.UnitType + ' PRICE'"
            v-model.number="inventory.unitPrice"
            :rules="PriceRule"
            required
          ></v-text-field> -->

          <v-toolbar dense class="elevation-0">
            <v-spacer></v-spacer>
            <v-btn :disabled="isloading" class="mr-3 error" @click="Cancel"
              >Cancel</v-btn
            >

            <v-btn :loading="isloading" @click="OnEdite" :disabled="!valid">
              submit
            </v-btn>
          </v-toolbar>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    EditeItems: { type: Object, required: true },
    OnFinish: { type: Function, required: true },
  },

  data() {
    return {
      dialog: false,
      isloading: false,
      valid: true,
      inventory: {},
      UnitQty: 0,
      QtyItems: 0,
      ItemNameRule: [v => !!v || "Item Name is required"],
      QtyRule: [
        v => !!v || "Qty is required",
        v => {
          if (v && !isNaN(v.replace(/,/g, "")))
            this.QtyItems = parseInt(v.replace(/,/g, ""));
          return (v && v.replace(/,/g, "")) >= 0 || `QTY ${v} is not allowed`;
        },
      ],
      PriceRule: [v => !!v || "Price is required"],
      Stock: "/stock/Ontheway",
    };
  },

  watch: {
    // UnitQty(v) {
    //   this.$nextTick(() => {
    //     if (!isNaN(v)) this.UnitQty = parseInt(v);
    //   });
    //   // console.log(v);
    // },
    dialog(v) {
      if (v) {
        this.inventory = { ...this.EditeItems };
        this.QtyItems = this.EditeItems.exp;

        this.UnitQty = Math.round(
          (this.EditeItems.exp - parseInt(this.EditeItems.exp)) *
            this.EditeItems.UnitQty
        );
        this.$nextTick(() => {
          // console.log();
          // this.UnitQty = Math.round(
          //   (this.EditeItems.exp - parseInt(this.EditeItems.exp)) *
          //     this.EditeItems.UnitQty
          // );
          // if (!this.UnitQty) this.UnitQty = 0;
          // this.inventory = { ...this.EditeItems };
          // this.QtyItems = this.EditeItems.exp;
          // this.QtyItems = 10;
        });
      }
    },
  },
  methods: {
    UnitRule(val) {
      if (this.QtyItems == 0 && val == 0) return "0 is not allowed";
      if (val >= 0 && val < this.EditeItems.UnitQty) return true;
      return `${val} Units is not allowed`;
    },
    OnEdite() {
      if (this.$refs.EnvEditeForm.validate()) {
        // Native Form submission is not yet supported
        // console.log("Suuceess");
        const ItemInfo = { ...this.inventory, exp: this.QtyItems };
        if (this.UnitQty > 0)
          ItemInfo.exp = this.UnitQty / this.EditeItems.UnitQty + this.QtyItems;
        this.isloading = true;
        this.$store
          .dispatch("UPDATE_ONLY", {
            url: this.Stock + "/itemEdite",
            data: ItemInfo,
          })
          .then(result => {
            this.OnFinish(result.data, true);
            this.Cancel();
            // this.isloading = false;
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            this.isloading = false;
            // console.log("Final");
          });
      }
    },
    Cancel() {
      // this.$refs.EnvEditeForm.reset();
      this.inventory = {};
      this.UnitQty = 0;
      this.dialog = false;
    },
  },
  //   mounted() {
  //     // this.inventory = Object.assign({}, this.EditeItems);
  //   }
};
</script>
